import React, { useMemo } from 'react';
import { UserSwitchOutlined } from '@ant-design/icons';
import {
    DashboardIcon,
    InventoryIcon,
    ImportIcon,
    MoveGroupsAndAppsIcon,
    ProjectIcon,
    ManageIcon,
    MigrateIcon,
    BackupIcon,
    RecoveryIcon,
    ReportingIcon,
    SupportIcon,
    DocumentationIcon,
} from '../../../components/icons';

// The anticon class puts these on the same 1em,
// font-size-driven sizing contract AntD's own icon components use inside Menu.
export const useIconMap = () => {
    return useMemo(
        () => ({
            dashboard: <DashboardIcon navIconDefault className="anticon nav-icon" />,
            inventory: <InventoryIcon navIconDefault className="anticon nav-icon" />,
            import: <ImportIcon navIconDefault className="anticon nav-icon" />,
            moveGroupsAndApps: <MoveGroupsAndAppsIcon navIconDefault className="anticon nav-icon" />,
            project: <ProjectIcon navIconDefault className="anticon nav-icon" />,
            manage: <ManageIcon navIconDefault className="anticon nav-icon" />,
            migrate: <MigrateIcon navIconDefault className="anticon nav-icon" />,
            backup: <BackupIcon navIconDefault className="anticon nav-icon" />,
            recovery: <RecoveryIcon navIconDefault className="anticon nav-icon" />,
            reporting: <ReportingIcon navIconDefault className="anticon nav-icon" />,
            admin: <UserSwitchOutlined style={{ color: 'white' }} />,
            support: <SupportIcon navIconDefault className="anticon nav-icon" />,
            documentation: <DocumentationIcon navIconDefault className="anticon nav-icon" />,
        }),
        [],
    );
};
